/**
 * Soft finalize gates — warn when checklist steps look incomplete.
 * Admins can still finalize after confirming.
 */
export const getFinalizeWarnings = (call, mailbox) => {
  if (!call) return [];
  const checklist = call.billingChecklist || {};
  const warnings = [];

  if (!call.invoiceNumber) {
    warnings.push('No invoice number');
  }
  if (!checklist.addedToQuickbooks) {
    warnings.push('Not marked as added to QuickBooks');
  }
  if (!checklist.printed) {
    warnings.push('Not printed / PDF downloaded');
  }
  if (mailbox === 'franklin' && !checklist.franklinSentAt) {
    warnings.push('Not sent to Franklin');
  }
  if (mailbox === 'cspire' && !checklist.cspireSentAt) {
    warnings.push('C Spire invoice not sent');
  }

  return warnings;
};

export const confirmFinalizeWithWarnings = (warnings) => {
  if (!warnings.length) return true;
  const list = warnings.map((w) => `• ${w}`).join('\n');
  return window.confirm(
    `Some billing steps are still incomplete:\n\n${list}\n\nFinalize anyway?`
  );
};
